import React from 'react';
import type ProjectSettingsServiceDeskAutomationSummaryType from '@atlassian/jira-spa-apps-project-settings-service-desk-automation-summary/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationSummary = lazyForPaint<
	typeof ProjectSettingsServiceDeskAutomationSummaryType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-summary", jiraSpaEntry: "async-project-settings-service-desk-automation-summary" */ '@atlassian/jira-spa-apps-project-settings-service-desk-automation-summary'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationSummary}
		pageId="project-settings-automation-summary"
		shouldShowSpinner
	/>
);
